export default __webpack_public_path__ + "static/media/image4.cd3f9c9b.webp";